import Backbone from 'backbone';
import AnalyticsQueryString from '@component/common/src/util/AnalyticsQueryString';
import {
  AddToBag,
  Cookies,
} from '../util/Constants';
import AttributesHelper from '../util/AttributesHelper';
import CookieUtil from '../util/CookieUtil';
import Properties from '../util/Properties';
import { getProperty } from '../util/PropertyGetter';

export default Backbone.Model.extend({

  url() {
    if (Properties.get('responsiveBagAddEnabled')) {
      return AddToBag.responsiveBagAddUrl;
    } else if (Properties.get('responsiveAddToBagEnabled')) {
      return AddToBag.responsiveAddToBagUrl;
    }
    return AddToBag.addToBagUrl;
  },

  initialize(data, options) {
    Object.assign(this, options);
    const { productModel } = this;
    this.attributesHelper = new AttributesHelper({
      productModel,
    });
    this.queryParams = AnalyticsQueryString.buildQueryMap();
    this.upcId = productModel.get('viewState').detail.selectedUpc.toString();


    this.setUpcIdAndNumber(productModel);
    this.setGiftCardFields();
    this.setSource();
    this.setChoiceId();
    this.setListItemId();
    this.setMergeBag();
    this.setCategoryId();
    this.setBOPSfields();
    this.set('trackingCategory', this.attributesHelper.getPageCategoryID());
    this.set('prodSelectionInfo', this.getProdSelectionInfo());
    this.set('optedProtectionPlanId', getProperty(productModel, 'attributes.viewState.detail.selectedPlanId') || 0);
    this.set('quantity', productModel.get('viewState').detail.selectedQuantity);
    this.set('pdpAtbProtectionPlanEligible', getProperty(productModel, 'attributes.product.detail.flags.protectionPlanEligible'));
  },

  setUpcIdAndNumber(productModel) {
    if (Properties.get('responsiveBagAddEnabled')) {
      this.set('upcId', this.upcId);
      this.set('upcNumber', getProperty(productModel, 'attributes.viewState.detail.selectedUpcItem.identifier.upcNumber'));
    } else {
      this.set(`upcId["${this.upcId}"]`, this.productModel.get('viewState').detail.selectedQuantity);
    }
  },

  getProdSelectionInfo() {
    const helper = this.attributesHelper;
    const { product, viewState } = this.productModel.attributes;
    const todaysDate = new Date();

    return Object.entries({
      // This extra `&` is required for Shop5 tag in bag page
      '&PseudoCat': this.get('trackingCategory'),
      PseudoProdID: product.id,
      LinkType: helper.getUrlParam('LinkType') && helper.getUrlParam('LinkType').replace('%26', '1_38_'),
      widget: helper.getUrlParam('widget') && helper.getUrlParam('widget').replace('%26', '1_38_'),
      productVideo: product.imagery.videoId && 'ENHANCED_FEATURES_VIDEO',
      BagDate: [todaysDate.getMonth() + 1, todaysDate.getDate(), todaysDate.getFullYear()].join('/'),
      breadCrumbCategory: viewState.detail.breadCrumbCategory,
      productCategoryName: viewState.detail.breadCrumbCategory,
      productSize: viewState.detail.selectedSize !== undefined && product.traits.sizes.sizeMap[viewState.detail.selectedSize].displayName,
    }).filter(keyValPair => keyValPair[1]) // removes null values
      .map(keyValPair => `${keyValPair[0]}=${encodeURIComponent(keyValPair[1])}`) // makes array of "key=val"
      .join('&');
  },

  getPageType() {
    const product = this.productModel.get('product');
    const productFlags = product.detail.flags;
    const viewFlags = this.productModel.get('viewState').detail.flags;
    let pageType;

    if (productFlags.masterProduct === true || viewFlags.isMemberCard) {
      pageType = 'master';
    } else if (productFlags.memberProduct === true) {
      pageType = 'member';
    } else {
      pageType = 'single item';
    }

    return pageType;
  },

  setGiftCardFields() {
    if (this.productModel.get('viewState').giftCard) {
      const {
        amount, email, toMessage, fromMessage, message,
      } = this.productModel.get('viewState').giftCard;
      this.set('giftCardAmount', amount);
      this.set('giftUPCID', this.upcId);
      // For new bag Xapi /add call.
      if (Properties.get('responsiveBagAddEnabled')) {
        if (email) {
          this.set('giftCardEmailId', email);
        }

        // optional values
        if (toMessage) {
          this.set('giftCardToName', toMessage);
        }

        if (fromMessage) {
          this.set('giftCardFromName', fromMessage);
        }

        if (message) {
          this.set('giftCardMessage', message);
        }
      } else {
        if (email) {
          this.set('giftCardEmail', email);
        }

        // optional values
        if (toMessage) {
          this.set('toMessage', toMessage);
        }

        if (fromMessage) {
          this.set('fromMessage', fromMessage);
        }

        if (message) {
          this.set('message', message);
        }
      }

      if (!this.productModel.get('viewState').detail.isEGift) {
        this.set('productType', this.productModel.get('product').detail.typeName);
      }
    }
  },

  setSource() {
    this.set('source', this.source);
  },

  setChoiceId() {
    const { choiceId } = this.queryParams;
    if (choiceId) {
      this.set('choiceId', choiceId);
    }
  },

  setListItemId() {
    const { listItemId, upc_ID: upcIdParam } = this.queryParams;
    if (!!listItemId && this.upcId === upcIdParam) {
      this.set('listType', 'WISH_LIST');
      this.set('listItemId', listItemId);
    }
  },

  setMergeBag() {
    const { mergeBag } = this.queryParams;
    if (mergeBag) {
      this.set('mergeBag', mergeBag);
    }
  },

  setCategoryId() {
    const categoryId = this.productModel.get('product').relationships.taxonomy.defaultCategoryId;
    if (categoryId !== undefined) {
      this.set('categoryId', categoryId);
    }
  },

  setBOPSfields() {
    if (this.productModel.get('viewState').detail.isPickUpInStoreSelected) {
      const storeLocation = CookieUtil.getNumberCookie(Cookies.bopsPickupInStore, Cookies.miscGCs);

      this.set({
        deliveryOption: 'pickInStore',
        storeLocation,
      });
    }
  },
});



// WEBPACK FOOTER //
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/node_modules/@page/digital-product-ui-mcom/src/js/add-to-bag/AddToBagModel.js